export default __webpack_public_path__ + "static/media/Serpentine Barrier.503d1861.png";